import { useCallback } from 'react';

import { API_URLS, APPLICATION_HEADERS } from '../../../components/common/headers';
import { isEqualDeep } from '../../../utils/objects/isEqualDeep';
import { protectApiViaOkta } from '../../../utils/protectApiViaOkta';

export const useFetchTransactions = ({
  rowsPerPage,
  setIsLoading,
  setIsRendering,
  setIsEmptyResponse,
  preSearchRequestTransactionsObjectRef,
  setSearchReqTransactionsObject,
  setIsEditDeleteSuccessCB,
  setResponseData,
  sortField,
  sortDirection,
}) => {
  const defaultPageSize = 50;

  const fetchPage = useCallback(
    async ({ currentPage, reqObject, force = false, customPageSize }) => {
      const pageSize = customPageSize ?? rowsPerPage ?? defaultPageSize;

      const payload = {
        ...reqObject,
        callNumber: currentPage,
        pageSize,
        ...(sortField && {
          sortField:
            sortField === 'provider_updated_date'
              ? 'updated_date'
              : sortField === 'formatted_address'
              ? 'address'
              : sortField === 'provider_name'
              ? 'provider_name'
              : sortField,
        }),
        ...(sortField && { sortDirection: sortDirection }),
      };

      setSearchReqTransactionsObject(payload);

      if (isEqualDeep(payload, preSearchRequestTransactionsObjectRef.current) && !force) {
        return;
      }

      setIsLoading(true);
      setIsRendering(false);
      preSearchRequestTransactionsObjectRef.current = payload;

      try {
        const resp = await protectApiViaOkta('post', API_URLS.searchProviderLocationsURL, payload);

        if (resp?.status === 200 && Array.isArray(resp.data)) {
          const offset = (currentPage - 1) * pageSize;

          const mapped = resp.data.map((item, i) => ({
            ...item,
            emailContacts: item?.provider_contact_info?.map((s) => s?.email) || [],
            provider_updated_date: item?.provider_updated_date || item?.provider_created_date,
            SERIAL_NO: offset + i + 1,
          }));

          setResponseData(mapped);
          setIsEmptyResponse(mapped.length === 0);
        } else {
          setResponseData([]);
          setIsEmptyResponse(true);
        }
      } catch (e) {
        console.error('Error fetching data:', e);
        setResponseData([]);
        setIsEmptyResponse(true);
      } finally {
        setIsLoading(false);
        setIsRendering(true);
        setIsEditDeleteSuccessCB(false);
      }
    },
    [
      rowsPerPage,
      sortField,
      sortDirection,
      setIsLoading,
      setIsRendering,
      setIsEmptyResponse,
      preSearchRequestTransactionsObjectRef,
      setSearchReqTransactionsObject,
      setIsEditDeleteSuccessCB,
      setResponseData,
    ],
  );

  return { fetchPage };
};
